<template>
  <div class="sms-wrap">

    <div class="tab-loading" v-if="loading">
      <i class="fa fa-spinner fa-spin"></i> Loading configuration…
    </div>

    <template v-else>
      <form @submit.stop.prevent="onSubmit">

        <div class="form-group toggle-row">
          <div class="toggle-info">
            <div class="toggle-label">Enable SMS Notifications</div>
            <div class="toggle-sub">Send appointment and status SMS messages via Twilio</div>
          </div>
          <button type="button" class="toggle-btn" :class="{ on: send_sms }" @click="send_sms = !send_sms">
            <span class="toggle-knob"></span>
          </button>
        </div>

        <div class="section-divider">
          <span>Twilio Credentials</span>
        </div>

        <div class="form-group">
          <label>SMS Provider <span class="req">*</span></label>
          <select class="field field-select" v-model="sms_provider">
            <option value="twilio">Twilio</option>
          </select>
        </div>

        <div class="form-group">
          <label>Account SID <span class="req">*</span></label>
          <input type="text" class="field" v-model="account_sid"
            :class="{ 'field-err': errors['account_sid'] }"
            placeholder="ACxxxxxxxxxxxxxxxx" />
          <span v-if="errors['account_sid']" class="err-msg">{{ errors["account_sid"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Auth Token <span class="req">*</span></label>
          <input type="text" class="field" v-model="auth_token"
            :class="{ 'field-err': errors['auth_token'] }"
            placeholder="Your Twilio auth token" />
          <span v-if="errors['auth_token']" class="err-msg">{{ errors["auth_token"][0] }}</span>
        </div>

        <div class="form-group">
          <label>From Number <span class="req">*</span></label>
          <input type="text" class="field" v-model="from_number"
            :class="{ 'field-err': errors['from_number'] }"
            placeholder="+1 (xxx) xxx-xxxx" />
          <span v-if="errors['from_number']" class="err-msg">{{ errors["from_number"][0] }}</span>
        </div>

        <div class="form-footer">
          <button class="btn-save" type="submit" ref="kt_sms_config_submit">
            <i class="fa fa-check"></i> Save
          </button>
        </div>

      </form>
    </template>

  </div>
</template>

<script>
import {
  FETCH_SMS_CONFIG,
  SUBMIT_SMS_CONFIG
} from "@/core/services/store/actions.type";

export default {
  data() {
    return {
      loading: true,
      account_sid: "",
      sms_provider: "twilio",
      auth_token: "",
      from_number: "",
      send_sms: false,
      errors: [],
      id: 0
    };
  },
  created() {
    this.$store.dispatch(FETCH_SMS_CONFIG).then(data => {
      const d = data.data;
      this.account_sid  = d.account_sid  || "";
      this.sms_provider = d.sms_provider || "twilio";
      this.auth_token   = d.auth_token   || "";
      this.from_number  = d.from_number  || "";
      this.send_sms     = !!d.send_sms;
      this.id           = d.id           || 0;
      this.loading = false;
    }).catch(() => { this.loading = false; });
  },
  methods: {
    onSubmit() {
      this.errors = [];
      const btn = this.$refs["kt_sms_config_submit"];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(SUBMIT_SMS_CONFIG, {
        account_sid:  this.account_sid,
        sms_provider: this.sms_provider,
        auth_token:   this.auth_token,
        from_number:  this.from_number,
        send_sms:     this.send_sms,
        id_: this.id
      }).then(data => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
        this.$toastr.s(data.msg);
      }).catch(err => {
        this.errors = err.msg;
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$green:  #276749;
$dark:   #0d1b3e;
$border: #dde2ec;

.sms-wrap { font-family: $font; }

.tab-loading {
  display: flex; align-items: center; gap: 10px;
  padding: 40px 0; color: #8a94a6; font-size: 13px;
  i { color: $blue; font-size: 18px; }
}

.form-group { margin-bottom: 18px; }

label {
  display: block;
  font-size: 11px; font-weight: 700;
  color: #4a5568;
  text-transform: uppercase; letter-spacing: 0.4px;
  margin-bottom: 6px;
}
.req { color: #e53e3e; }

.field {
  display: block; width: 100%;
  height: 38px;
  border: 1.5px solid $border; border-radius: 8px;
  padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  background: #fff;
  transition: border-color 0.15s;
  box-shadow: none; outline: none;
  &:focus { border-color: $blue; }
  &.field-err { border-color: #e53e3e; }
}

.field-select {
  padding-right: 32px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 12px center;
  appearance: none;
  cursor: pointer;
}

/* SMS enable toggle */
.toggle-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 16px;
  background: #f7f9fc;
  border: 1.5px solid $border;
  border-radius: 10px;
}
.toggle-info { flex: 1; }
.toggle-label { font-size: 13px; font-weight: 600; color: $dark; }
.toggle-sub   { font-size: 11px; color: #8a94a6; margin-top: 2px; }

.toggle-btn {
  position: relative;
  width: 44px; height: 24px;
  border-radius: 12px;
  border: none; cursor: pointer;
  background: #d1d5db;
  transition: background 0.2s;
  flex-shrink: 0;
  &.on { background: $blue; }
}
.toggle-knob {
  position: absolute;
  top: 3px; left: 3px;
  width: 18px; height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  transition: transform 0.2s;
  .toggle-btn.on & { transform: translateX(20px); }
}

/* Section divider */
.section-divider {
  display: flex; align-items: center; gap: 10px;
  margin: 22px 0 18px;
  span {
    font-size: 11px; font-weight: 700;
    color: #8a94a6; text-transform: uppercase; letter-spacing: 0.5px;
    white-space: nowrap;
  }
  &::before, &::after {
    content: ''; flex: 1; height: 1px; background: #f0f3fa;
  }
}

.err-msg { font-size: 11px; color: #e53e3e; margin-top: 3px; display: block; }

.form-footer {
  display: flex; justify-content: flex-end;
  padding-top: 24px; margin-top: 8px;
  border-top: 1px solid #f0f3fa;
}

.btn-save {
  display: inline-flex; align-items: center; gap: 7px;
  height: 38px; padding: 0 24px; border-radius: 8px;
  border: none; background: $green;
  color: #fff; font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: background 0.15s;
  i { font-size: 12px; }
  &:hover { background: #1d5230; }
  &:disabled { opacity: 0.6; cursor: default; }
}
</style>
